export { default } from './HistoricsLineChart';
